const slice = Array.prototype.slice;
let Promise;

if (typeof window !== 'undefined') {
  Promise = window.Promise;
}

if (typeof global !== 'undefined') {
  Promise = global.Promise;
}

function promisify(func) {
  if (Promise) {
    return function () {
      const args = slice.call(arguments);
      const ctx = this;

      if (typeof args.slice(-1) === 'function') {
        return func.apply(ctx, args);
      } else {
        return new Promise(function (resolve, reject) {
          args.push(function (err, result) {
            if (err) {
              reject(err);
            } else {
              resolve.apply(this, slice.call(arguments, 1));
            }
          });
          func.apply(ctx, args);
        });
      }
    };
  } else {
    return func;
  }
}

export default promisify;